import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

class PremiumFeature extends Component {
  render() {
    const { isPremium, premiumComponent, regularComponent } = this.props;

    return (
      <React.Fragment>
        {isPremium ? premiumComponent : regularComponent}
      </React.Fragment>
    );
  }
}

PremiumFeature.propTypes = {
  isPremium: PropTypes.bool.isRequired,
  premiumComponent: PropTypes.element.isRequired,
  regularComponent: PropTypes.element
};

PremiumFeature.defaultProps = {
  premiumComponent: null,
  regularComponent: null
};

const mapStateToProps = (state) => {
  return {
    isPremium: state.getIn(['currentUser', 'data', 'premium'])
  };
};

export default connect(mapStateToProps)(PremiumFeature);



// WEBPACK FOOTER //
// ./app/components/shared/PremiumFeature.jsx